// TODO
import {
  type FormatLongFnOptions,
  type Locale,
  cs,
  da,
  de,
  enAU,
  enCA,
  enGB,
  enIE,
  enIN,
  enNZ,
  enUS,
  es,
  fi,
  fr,
  frCA,
  hr,
  hu,
  it,
  itCH,
  ja,
  ko,
  nb,
  nl,
  nlBE,
  pl,
  pt,
  ro,
  sk,
  sl,
  sr,
  sv,
} from "date-fns/locale";

// For some reason, the date-fns locales make frCA dates 24-01-18 instead of 2024-01-18
const frCaOverride = {
  ...frCA,
  formatLong: {
    ...frCA.formatLong,
    date: (options: FormatLongFnOptions) => {
      return `yy${frCA.formatLong?.date?.(options)}`;
    },
    dateTime: (options: FormatLongFnOptions) => {
      return `yy${frCA.formatLong?.dateTime?.(options)}`;
    },
    time: (options: FormatLongFnOptions) => {
      return frCA.formatLong?.time?.(options);
    },
  },
};

export const dateFnsLocalesMap: Record<string, Locale> = {
  "ca-ES": es,
  "cs-CZ": cs,
  "da-DK": da,
  "de-AT": de,
  "de-CH": de,
  "de-DE": de,
  "de-NL": nl,
  "en-AT": de,
  "en-AU": enAU,
  "en-CA": enCA,
  "en-CH": de,
  "en-DE": de,
  "en-DK": da,
  "en-ES": es,
  "en-FI": fi,
  "en-FR": fr,
  "en-GB": enGB,
  "en-HR": hr,
  "en-IE": enIE,
  "en-IN": enIN,
  "en-IT": it,
  "en-JP": ja,
  "en-NL": nl,
  "en-NO": nb,
  "en-PL": pl,
  "en-PT": pt,
  "en-RO": ro,
  "en-RS": sr,
  "en-SE": sv,
  "en-SI": sl,
  "en-US": enUS,
  "en-XZ": enUS,
  "en-NZ": enNZ,
  "es-ES": es,
  "es-US": es,
  "eu-ES": es,
  "fi-FI": fi,
  "fr-BE": fr,
  "fr-CA": frCaOverride,
  "fr-CH": fr,
  "fr-FR": fr,
  "gl-ES": es,
  "hr-HR": hr,
  "hu-HU": hu,
  "it-CH": itCH,
  "it-IT": it,
  "ja-JP": ja,
  "ko-KR": ko,
  "en-KR": ko,
  "nl-BE": nlBE,
  "nl-NL": nl,
  "no-NO": nb,
  "pl-PL": pl,
  "pt-EN": pt,
  "pt-PT": pt,
  "ro-RO": ro,
  "sk-SK": sk,
  "sl-SI": sl,
  "sr-RS": sr,
  "sv-FI": sv,
  "sv-SE": sv,
};
